<template>
  <div id="app">
    <div class="main-wrapper">
      <router-view />
    </div>

  <div v-if="loading" class="loading-overlay">
  <div class="spinner-border text-primary" role="status" style="width: 3rem; height: 3rem;">
  <span class="visually-hidden">Loading...</span>
  </div>
  </div>

  <agent-chat-widget></agent-chat-widget>

  </div>
</template>
<script>
export default {
  name: "App",
  data() {
    return {
      loading: false,
    };
  },
  provide() {
    // This allows child components to toggle the global loading state
    return {
      setLoading: (value) => this.loading = value
    };
  }
};
</script>
